import React, { useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import '../../../assets/images/codestyle.css';
import ScrollToTop from '../../Shared/ScrollToTop';
import { ProjectTypeContext } from '../../../ContextHandle'
const Recommendation = ({ setActivePage, sectionRefs, setDocumentation, setDefaultAppActiveMenu }) => {
     /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(501);
        setDocumentation(2);
        document.title = 'Recommendation | ' + projectName;
        setDefaultAppActiveMenu(1);
    }, [setActivePage, setDocumentation, projectName]);


    return (
        <div className='d-flex   justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div id="system-requirements  " className='pt-5 right-content-box-width' >
                <nav  >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">App Basics</li>
                        <li className="breadcrumb-item active" aria-current="page">Recommendation</li>
                    </ol>
                </nav>

                <h3 className="pt-5 font-weight-bold">Recommendation</h3>
                <p className='pt-3'>We recommend using the latest stable Android Studio, Flutter SDK, Dart SDK, and Xcode/CocoaPods for iOS builds. Download and install them before opening the Merchant or Delivery app source code.</p>
                <p><a href='https://developer.android.com/studio?hl=en' target="_blank" className='text-primary font-weight-bold'>Android Studio</a>, <a href='https://docs.flutter.dev/get-started/install' target="_blank" className='text-primary font-weight-bold'>Flutter SDK</a>, <a href='https://guides.cocoapods.org/using/getting-started.html' target="_blank" className='text-primary font-weight-bold'>CocoaPods</a></p>
                <h4 className="pt-3">Recommended Version</h4>
                <ul>
                    <li>Android Studio latest stable version.</li>
                    <li>Flutter latest stable 3.x version.</li>
                    <li>Dart SDK 3.10.1 or later.</li>
                    <li>Xcode latest stable version for iOS builds.</li>
                    <li>CocoaPods latest stable version for iOS dependency installation.</li>
                </ul>
                <h4 className="pt-3">Before Running the Apps</h4>
                <ul>
                    <li>Run <code>flutter pub get</code> in each app source folder.</li>
                    <li>Configure your API URL and API key in <code>lib/services/api-list.dart</code>.</li>
                    <li>Replace Firebase configuration files with your own Firebase project files.</li>
                    <li>Add your Google Maps API key if map features are enabled.</li>
                    <li>Configure your own app name, package name, app icon, and release signing key before publishing.</li>
                </ul>
                <div className='pt-3'>

                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Getting Started</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/app/installation`} className="text-decoration-none">
                            <a href="/#" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Installation</h4>
                        </NavLink>
                    </div>
                </div>
            </div>



        </div>

    );

};

export default Recommendation;
